import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    attachments: { type: Array, default: [] },
  }

  connect() {
    this.renderModal()
    this.setupEventListeners()
  }

  renderModal() {
    this.element.innerHTML = `
      <div data-controller="protos--modal" data-action="click->gallery-modal#close">
        <dialog data-protos--modal-target="dialog" class="modal modal-open modal-bottom sm:modal-middle backdrop-blur-sm">
          <div class="modal-box flex flex-col gap-xs">
            <div class="p-4 border-b border-base-300 flex justify-between items-center">
              <h3 class="text-lg font-semibold">Select Image</h3>
              <button class="btn btn-sm btn-ghost" data-action="click->gallery-modal#close">×</button>
            </div>
            <div class="p-4 grid grid-cols-4 gap-4 overflow-y-auto flex-grow" data-gallery-modal-target="grid">
              ${this.renderAttachments()}
            </div>
            <div class="p-4 border-t border-base-300 flex justify-end">
              <button class="btn btn-ghost" data-action="click->gallery-modal#close">Cancel</button>
            </div>
          </div>
        </dialog>
      </div>
    `
  }

  renderAttachments() {
    return this.attachmentsValue
      .filter((attachment) => attachment.mime_type?.startsWith("image/"))
      .map(
        (attachment) => `
        <div class="cursor-pointer rounded-lg overflow-hidden border border-base-300 hover:border-primary transition"
             data-action="click->gallery-modal#select"
             data-url="${attachment.url}">
          <img src="${attachment.thumbnail_url}" alt="${attachment.filename}" class="w-full h-32 object-cover" />
          <div class="p-2 text-xs truncate">${attachment.filename}</div>
        </div>
      `
      )
      .join("")
  }

  setupEventListeners() {
    // The event listeners are already set up via data-action attributes
  }

  select(event) {
    const url = event.currentTarget.dataset.url
    this.dispatch("select", { detail: { url } })
  }

  close() {
    this.dispatch("close")
    this.element.remove()
  }
}
